import React, { Component, useState } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Paper from '@material-ui/core/Paper';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';

import validate from 'validate.js';

import theme from './theme';
import visitorTheme from './visitorTheme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import VisitorRoutes from './VisitorRoutes'; 
import UserRoutes from './UserRoutes'; 
import {Elements, StripeProvider} from 'react-stripe-elements';
 
import { DndProvider } from 'react-dnd'
import Backend from 'react-dnd-html5-backend'

import apiManager from './ApiManager';

import TagManager from 'react-gtm-module';
import { GTM_ID, USE_LOCAL } from './constants';



// LIVE ENV ONLY: Set up Google Tag Manager - which is the only way to
// integrate react-gtm-module with Google Analytics v4
if(!USE_LOCAL) {
  
  const tagManagerArgs = {
    gtmId: GTM_ID
  }

  TagManager.initialize(tagManagerArgs)
}

const browserHistory = createBrowserHistory();

validate.validators = {
  ...validate.validators,
  ...validators
};

export default class App extends Component {

    constructor(props) {
        super();

        // we generate a MUI-theme from state's theme object
       // const muiTheme = createMuiTheme(visitorTheme);

        this.state = {
            user: null,
            isAuthenticated: false,
            isAuthenticating: true,
            isAdmin: sessionStorage.getItem('isAdmin'),
            fullName: '',
            shadowName: null,
        //    muiTheme: muiTheme,
            currentThemeName: 'visitor',
        };
    }

    // [theme, setTheme] = useState({
    //     palette: {
    //       type: "light"
    //     }
    //   });

    // we change the palette type of the theme in state
    toggleTheme = (color) => {
        // let newPaletteType = theme.palette.type === "light" ? "dark" : "light";
        // this.setState({
        //     currentTheme: {
        //         palette: {
        //             type: newPaletteType
        //         }
        //     }
        // });
    };


    async componentDidMount() {
        try {
            const authData = await apiManager.currentSession();
         //   const me = await getMe(authEmail);
            await this.userHasAuthenticated(true);

        }
        catch (e) {
            if (e !== 'No current user') {
                alert(e);
            }
        }
        this.setState({ isAuthenticating: false });
    }

    userHasAuthenticated = async (authenticated) => {
        if (authenticated) {
            this.setState({
                isAuthenticated: true,
                user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}
            })
        } else {
            this.setState({ isAuthenticated: false });
        }
    }

    handleLogout = async history => {
        await apiManager.signOut();
        sessionStorage.clear();
        localStorage.clear();
        await this.userHasAuthenticated(false);
        history.push("/signin");
    }

    setShadowName = name => {
        this.setState({ shadowName: name });
    }

    switchToAdmin = () => {
        sessionStorage.removeItem('shadowId');
        sessionStorage.removeItem('shadowName');
        this.setShadowName(null);

        alert(`Switching to your admin view...`);
        this.props.history.push('/');
    }

    scrollToTop() {
        const scrollToElement = document.getElementById('verytop');
        scrollToElement.scrollIntoView({ behavior: 'smooth' });
    }


  render() { 
    const childProps = {
        isAuthenticated: this.state.isAuthenticated,
        userHasAuthenticated: this.userHasAuthenticated,
        handleLogout: this.handleLogout,
    };
    const {isAuthenticating, isAuthenticated} = this.state;

    if (isAuthenticating) {
        return( <div></div>)
    }

    
    return ( 
    <>
    {/* <StripeProvider apiKey={STRIPE_PUBLIC_KEY}> */}
    {/* ROUTES FOR VISITOR (NOT-ATHENTICATED USER) */}
    {!isAuthenticated && (
                <>     
                    {/* <MuiThemeProvider theme={this.state.muiTheme}> */}
                 
                        <Router history={browserHistory}>
                            <DndProvider backend={Backend}>
                                <Elements>
                                <ScopedCssBaseline>      
                                    <VisitorRoutes  appProps={childProps}  />
                                 </ScopedCssBaseline>
                                </Elements>
                            </DndProvider>
                        </Router>
                    {/* </MuiThemeProvider> */}
                </>
    )}

    {/* ROUTES FOR AUTHENTICATED USER */}
    {isAuthenticated && (
                // <ThemeProvider theme={theme}>
                // <MuiThemeProvider theme={this.state.muiTheme}>
                    <Router history={browserHistory}>
                        <DndProvider backend={Backend}>
                            <Elements>
                                <UserRoutes user={this.state.user} appProps={childProps} history={browserHistory}  />
                            </Elements>
                        </DndProvider>
                    </Router>
                    // </MuiThemeProvider>
                // </ThemeProvider> 
    )}
      {/* </StripeProvider> */}
      </>
    );
  }
}
